module.exports = __webpack_public_path__ + "./docs/img/kit-functions.d53ec9bbad3dbc26352fce37523b2f3f.svg";